module.exports = __webpack_public_path__ + "img/4.fcda273a.jpg";